import { Box, ButtonBase, Typography } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

import { AccessibleTooltip } from '@/components/AccessibleTooltip'
import type { IncludeExclude } from '@/models/DatabaseSearch'
import SegmentedRadio from './SegmentedRadio'
import { NAVY } from './styles'

interface IncludeExcludeToggleProps {
  label: string
  tooltip?: string
  value: IncludeExclude
  onChange: (value: IncludeExclude) => void
}

/** A labelled Include / Exclude switch. Exactly one side is always chosen. */
export default function IncludeExcludeToggle({
  label,
  tooltip,
  value,
  onChange,
}: IncludeExcludeToggleProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        my: 0.75,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        {tooltip && (
          <AccessibleTooltip title={tooltip} describeChild>
            <ButtonBase
              type="button"
              disableRipple
              aria-label={`About ${label}`}
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                '&.Mui-focusVisible': { outline: `2px solid ${NAVY}`, outlineOffset: 1 },
              }}
            >
              <HelpOutlineIcon aria-hidden="true" sx={{ fontSize: '20px', color: '#757575' }} />
            </ButtonBase>
          </AccessibleTooltip>
        )}
      </Box>
      <SegmentedRadio
        label={label}
        value={value}
        options={[
          { value: 'include', label: 'Include' },
          { value: 'exclude', label: 'Exclude' },
        ]}
        onChange={onChange}
      />
    </Box>
  )
}
